import actionTypes from '../actions/actionTypes';

const initialState = { isVisible: true };

const globalNavigation = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HIDE_GLOBAL_NAVIGATION:
      return { isVisible: false };
    case actionTypes.SHOW_GLOBAL_NAVIGATION:
      return { isVisible: true };
    default:
      return state;
  }
};

export default globalNavigation;
